//#region Asset Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

//#region IMR Imports

import { IMRPopupOptions, IIMRPopup } from '@imr/controls.angularjs/components/overlay/popup'

//#endregion

import { Activity, Enums } from '../../../../models/common'
import { OpDepositoryElement, OpPackage } from '../../../../models/core'

import { TypeHelper, LocalizationHelper } from '../../../../helpers'

import { GridDataSourceType, GridTypes, GridController, GridOptions } from '../../../common/grid'

import { PackageConfirmOpitons, IPackageConfirm } from './package-confirm.interfaces'

import { PackageContentService } from '../../../../services/package'
import { UserSessionService } from '../../../../services/user-session'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

export class PackageConfirmController implements ng.IComponentController, IPackageConfirm {

    // #region Consts

    private get PACKAGE_CONFIRM_GRID_EDIT_NAME(): string { return 'PACKAGE_CONFIRM_GRID_EDIT_NAME' }

    // #endregion

    // #region Memebers

    public imrPopupOptions: IMRPopupOptions
    public packageConfirmGridOptions: GridOptions

    private confirmAllButton: DevExpress.ui.dxButton
    private currentPackage: OpPackage
    private confirmSubmitButton: DevExpress.ui.dxButton
    private imrPopup: IIMRPopup
    private options: PackageConfirmOpitons
    private packageConfirmGrid: GridController<OpDepositoryElement>


    // #endregion

    //#region Ctor

    constructor(
        private packageContentService: PackageContentService,
        private userSessionService: UserSessionService
    ) {
    }

    // #endregion

    // #region ng.IComponentController Implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // #endregion

    // #region Component

    private initialize(): void {
        this.initializePopupOptions()
        this.onInitialized()
    }

    // #endregion

    // #region Grid

    private initializeConfirmGridEdit(): void {
        this.currentPackage = this.options.packToConfirm
        this.packageConfirmGridOptions = {
            addCustomFilters: true,
            dataSourceType: GridDataSourceType.Properties,
            columnsDictionary: this.packageContentService.getConfirmGridColumns(),
            name: this.PACKAGE_CONFIRM_GRID_EDIT_NAME,
            type: GridTypes.NO_SEARCH_BAR_SMALL_SINGLE_PAGE,
            editing: {
                allowUpdating: true,
                mode: "cell",
            },
            allowColumnReordering: !this.userSessionService
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageContent),

            buttonsOptions: {
                enabled: true
            },

            onInitialized: (e: any, grid: GridController<OpDepositoryElement>) => {
                this.packageConfirmGrid = grid
            },
            onRowUpdating: (e: any) => this.onRowUpdated(e),
            onContentReady: (e: any) => this.contentReady(),
            dataSource: new DataSource(this.currentPackage.contentList),
            onCellPrepared: (options: any) => this.packageContentService.getEditIconInCell(options, 'notes'),
        }
    }

    private onRowUpdated(e: any): void {
        const currentObj: OpDepositoryElement = _.find(this.currentPackage.contentList, (elem: OpDepositoryElement) => elem.idDepositoryElement == e.key.idDepositoryElement)
        if (e.newData.notes != null) {
            currentObj.notes = e.newData.notes
        }
        if (e.newData.accepted != null) {
            currentObj.accepted = e.newData.accepted
        }
        this.handleConfirmAllSubmitButton(!_.some(this.currentPackage.contentList, (depoElement: OpDepositoryElement) => depoElement.accepted == false || depoElement.accepted == null))
    }

    // #endregion


    // #region ImrPopup

    private initializePopupOptions(): void {
        this.imrPopupOptions = {
            bottomToolbarOptions: {
                innerOptions: {
                    items: [{
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
                            onClick: (e: any) => {
                                this.onSubmitButtonClick(e)
                            },
                            onInitialized: (e: any) => {
                                this.confirmSubmitButton = e.component
                            }
                        }
                    },
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SubmitAll),
                            onClick: (e: any) => {
                                this.onConfirmAllClick(e)

                            },
                            onInitialized: (e: any) => {
                                this.confirmAllButton = e.component
                            }
                        }
                    }]
                }
            },

            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
                deferRendering: true
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            }
        }
    }

    private onConfirmAllClick(e: any): void {
        this.currentPackage.contentList.forEach((depoElement: OpDepositoryElement) => {
            depoElement.accepted = true
            depoElement.opState = Enums.OpChangeState.Modified
        })
        this.handleConfirmAllSubmitButton(true)
    }


    private onSubmitButtonClick(e: any): void {
        this.currentPackage.opState = Enums.OpChangeState.Modified
        this.currentPackage.dataList.setValue(Enums.PackageStatus.Accepted, Enums.DataType.HELPER_ID_PACKAGE_STATUS)
        this.packageContentService
            .confirmPackage(this.currentPackage)
            .then((pakage: OpPackage) => {
                this.onPackageConfirmed()
                this.imrPopup.hide()
            })
    }

    private handleConfirmAllSubmitButton(isDisabled: boolean): void {
        this.confirmAllButton.option('disabled', isDisabled)
    }

    // #endregion


    // #region IPackageConfirm Implmentation 

    public show(): void {
        this.imrPopup.show()
        this.initializeConfirmGridEdit()
    }

    public handleConfirmSubmitButton(isDisabled: boolean): void {
        this.confirmSubmitButton.option('disabled', isDisabled)
    }

    public updateDataSource(pakage: OpPackage): void {
        if (this.packageConfirmGrid != null) {
            this.currentPackage = pakage
            this.packageConfirmGrid.setDataSource(this.currentPackage.contentList)
        }
    }

    public hide(): void {
        this.imrPopup.hide()
    }

    // #endregion


    // #region Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private contentReady(): void {
        if (this.options != null && _.isFunction(this.options.contentReady)) {
            this.options.contentReady()
        }
    }

    private onPackageConfirmed(): void {
        if (this.options != null && _.isFunction(this.options.onPackageConfirmed)) {
            this.options.onPackageConfirmed()
        }
    }

    // #endregion
}
